module.exports = __webpack_public_path__ + "img/142.228f533f.jpg";